"use strict";
//  Copyright 2018, Venkat Peri.
//
//  Permission is hereby granted, free of charge, to any person obtaining a
//  copy of this software and associated documentation files (the
//  "Software"), to deal in the Software without restriction, including
//  without limitation the rights to use, copy, modify, merge, publish,
//  distribute, sublicense, and/or sell copies of the Software, and to permit
//  persons to whom the Software is furnished to do so, subject to the
//  following conditions:
//
//  The above copyright notice and this permission notice shall be included
//  in all copies or substantial portions of the Software.
//
//  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
//  OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
//  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
//  NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
//  DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
//  OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
//  USE OR OTHER DEALINGS IN THE SOFTWARE.
Object.defineProperty(exports, "__esModule", { value: true });
var KeepState_1 = require("./KeepState");
exports.KeepState = KeepState_1.default;
var KeepStateAndData_1 = require("./KeepStateAndData");
exports.KeepStateAndData = KeepStateAndData_1.default;
var NextState_1 = require("./NextState");
exports.NextState = NextState_1.default;
var NextStateWithData_1 = require("./NextStateWithData");
exports.NextStateWithData = NextStateWithData_1.default;
var RepeatState_1 = require("./RepeatState");
exports.RepeatState = RepeatState_1.default;
var RepeatStateAndData_1 = require("./RepeatStateAndData");
exports.RepeatStateAndData = RepeatStateAndData_1.default;
var Result_1 = require("./Result");
var ResultWithData_1 = require("./ResultWithData");
exports.ResultWithData = ResultWithData_1.default;
var Stop_1 = require("./Stop");
exports.Stop = Stop_1.default;
exports.default = Result_1.default;
/**
 * @hidden
 * @param r
 * @return {r is ResultBuilder}
 */
function isResultBuilder(r) {
    return r.getResult !== undefined;
}
exports.isResultBuilder = isResultBuilder;
/**
 *
 * @hidden
 * @param r
 * @return {boolean}
 */
function isNextStateResult(r) {
    return r.type === 'nextState' || r.type === 'nextStateWithData';
}
exports.isNextStateResult = isNextStateResult;
function isPromiseResult(r) {
    return r.then !== undefined;
}
exports.isPromiseResult = isPromiseResult;
/**
 * @hidden
 *
 * @param r
 * @return {boolean}
 */
function isKeepStateResult(r) {
    return r.type === 'keepState' || r.type === 'keepStateAndData';
}
exports.isKeepStateResult = isKeepStateResult;
/**
 *
 * @hidden
 * @param r
 * @return {boolean}
 */
function isRepeatStateResult(r) {
    return r.type === 'repeatState' || r.type === 'repeatStateAndData';
}
exports.isRepeatStateResult = isRepeatStateResult;
/**
 *
 * @hidden
 * @param r
 * @return {boolean}
 */
function isResultWithData(r) {
    return r.hasData !== undefined;
}
exports.isResultWithData = isResultWithData;
//# sourceMappingURL=index.js.map